module.exports = __webpack_public_path__ + "img/57.f486cfe9.png";